/*global env*/
(function () {
    'use strict';

    angular.module('emarket.commons').constant('ENV', {
        env: env,
        isProduction: env === 'production'
    });
}());
